import { NavLink } from "react-router";
import type { Metas } from "../../types/Metas";
import { useTrads } from "../../contexts/trads/useTrads";

function MetasItem({meta}:{meta:Metas}) {
    const {translate}=useTrads();

    return (


            <div className="row">
                
                <h2>{meta.name}</h2>
                {meta.explication && <p>{meta.explication}</p>}
                <p>Content: {meta.value}</p>

                <NavLink to={`/metas/${meta.id.toString()}/edit`}> 
                    {translate('btn_edit')}
                </NavLink>

            </div>
        
    );
}
export default MetasItem;